import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon", "spinner"]

  declare readonly iconTarget: HTMLElement
  declare readonly spinnerTarget: HTMLElement

  showLoading (): void {
    this.iconTarget.classList.add("hidden")
    this.spinnerTarget.classList.remove("hidden")
  }
}
